// extracted by mini-css-extract-plugin
module.exports = {"contentBotons":"botons_contentBotons__Fudxf","boto":"botons_boto__SVElt"};